import type { IControlStatus } from '@/types/control'
export const CONTROL_STATUS: { [K in IControlStatus]: string } = {
  notApplicable: 'No Aplicable',
  notStarted: 'No Iniciado',
  inProgress: 'En Curso',
  completed: 'Completado',
}

export const CONTROL_TABLE = {
  TITLE: 'Controles',
  NAME: 'Nombre',
  STATUS: 'Estado',
  OWNER: 'Responsable',
  LAST_UPDATED: 'Última Edición',
  CLUSTER: 'Cluster',
  ID: 'ID',
  TREATMENT: 'Tratamiento',
  SEARCH_PLACEHOLDER: 'Buscar controles...',
}

export const CONTROL_DRAWER = {
  IMPLEMENTATION_GUIDE: 'Guía de Implementación',
  MISSING_IMPLEMENTATION_GUIDE: 'Falta la guía de implementación',
  MISSING_STANDARD_DESCRIPTION: 'Falta la descripción del estándar',
  NOT_FOUND_TITLE: 'Control No Encontrado',
  NOT_FOUND_DESCRIPTION: 'El control que está buscando no existe.',
  SELECT_OWNER: 'Seleccionar Responsable',
  STANDARD_DESCRIPTION: 'Descripción del Estándar',
  UPLOAD_EVIDENCES: 'Subir Evidencias',
  CONTROL_UPDATED: 'Control actualizado',
  STANDARD_CODE: 'ID del Estándar',
  STATUS: 'Estado',
  OWNER: 'Responsable',
  UPDATING: 'Actualizando control...',
  CONTROL_DETAILS: 'Detalles del Control',
  DESCRIPTION: 'Descripción',
  ATTRIBUTES: 'Atributos',
  RELATED_DOCUMENTS: 'Documentos Relacionados',
  RELATED_EVIDENCES: 'Evidencias Relacionadas',
}

export const CONTROL_FILTERS = {
  FILTER_BY_OWNER: 'Filtrar por Responsable',
  FILTER_BY_CLUSTER: 'Filtrar por Cluster',
  FILTER_BY_STANDARD: 'Filtrar por Estándar',
  ALL: 'Todos',
}

export const CONTROL_BULK_ACTIONS = {
  SELECTED: 'seleccionado',
  CONTROL: 'control',
  CONTROLS: 'controles',
  UPDATING: 'Actualizando...',
  CLEAR: 'Limpiar',
}

export const CONTROL_OWNER_SELECTOR = {
  SELECT_OWNER: 'Seleccionar responsable',
  SEARCH_USERS: 'Buscar usuarios...',
  LOADING: 'Cargando...',
  NO_USER_FOUND: 'No se encontró usuario.',
}

export const CONTROL_STATUS_SELECTOR = {
  SELECT_STATUS: 'Seleccionar estado',
}

export const CONTROL_COLUMN_FILTER = {
  ALL: 'Todos',
  CLEAR: 'Limpiar',
  SEARCH_PLACEHOLDER: 'Buscar...',
  NO_RESULTS: 'No se encontraron resultados.',
}
